/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Shared react-select style factories for PaymentModal registration fields.
 * @module modals/PaymentModal/paymentModalSelectStyles
 */

export const getSelectControlStyles = (baseStyles) => ({
  ...baseStyles,
  borderRadius: "8px",
  width: "100%",
  height: "30px",
  fontSize: "16px",
  cursor: "pointer",
  borderColor: "#909092",
});

export const getSelectContainerStyles = (baseStyles) => ({
  ...baseStyles,
});

export const getSelectValueContainerStyles = (baseStyles) => ({
  ...baseStyles,
});

export const getSelectInputStyles = (baseStyles) => ({
  ...baseStyles,
});

export const getSelectOptionStyles = (baseStyles) => ({
  ...baseStyles,
  cursor: "pointer",
});

export const getSelectOptionStylesWithTextAlign = (baseStyles) => ({
  ...baseStyles,
  textAlign: "left",
  cursor: "pointer",
});

export const getSelectContainerStylesWithTextAlign = (baseStyles) => ({
  ...baseStyles,
  textAlign: "left",
});

export const getSelectControlStylesWithTextOverflow = (baseStyles) => ({
  ...baseStyles,
  borderRadius: "8px",
  borderColor: "#909092",
  width: "100%",
  height: "30px",
  fontSize: "16px",
  cursor: "pointer",
  textOverflow: "ellipsis",
  textWrap: "nowrap",
  textAlign: "left",
  maxLines: 1,
});

export const getSelectControlStylesWithTextWrap = (baseStyles) => ({
  ...baseStyles,
  borderRadius: "8px",
  width: "100%",
  height: "30px",
  fontSize: "16px",
  cursor: "pointer",
  borderColor: "#909092",
  textAlign: "left",
  textWrap: "nowrap",
});

export const hideIndicatorSeparator = () => ({ display: "none" });
